import React, {Component} from 'react'
import "antd/dist/antd.css";
import Template from '../interfaz/Template';
import {connect} from 'react-redux';
import AuthenticatedComponent from '../AuthenticatedComponent';
import emitirMensaje from '../../redux/actions/emitirMensaje';
import acudirJDE from '../../img/info08_Acude_a_la_JDE.png';

let msjError = "";

export class AcudirJDE extends Component{ 
    
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    
    funcionListo= () => {

    }

    render(){
        return(
            <AuthenticatedComponent listo={this.funcionListo}>
                <Template contenido={
                    <React.Fragment>
                        <center>
                            <img src={acudirJDE} alt="AcudirJDE" width="60%" height="50%"/>
                            <p></p>                       
                        </center>
                    </React.Fragment>
                }/> 
            </AuthenticatedComponent>
        )
    } 
}

const mapStateToProps = state => {
    var datosAspirante;
    var proceso = undefined;

    // Obtenemos el proceso seleccionado de la store de redux
    if(state.menu.estados)
        if(state.menu.estados[state.menu.idEstado].procesos)
            proceso = state.menu.estados[state.menu.idEstado].procesos[state.menu.idDetalle];

    if (state.user.datosAspirante)
        datosAspirante = state.user.datosAspirante;
    
    return {
        datosAspirante: datosAspirante,  
        proceso: proceso     
    }
}

const mapDispatchToProps = {
    emitirMensaje,
};

export default connect(mapStateToProps, mapDispatchToProps)(AcudirJDE);
